module.exports = __webpack_public_path__ + "assets/img/back-b1082c1a.png";